const HandleOnClick = () => {
    window.open("https://drive.google.com/file/d/1NIwZX-WUUqmcVKWlSn3ThAZT7PRoqTZt/view?usp=sharing");
  }
  
  export default HandleOnClick;
  